import styled from 'styled-components';
import {
    getInitialSearchBoxValues,
    getSearchValidationSchema,
} from '@oberoninternal/travelbase-website/dist/components/SearchBox';
import { useRouter } from 'next/router';
import Formed from '@oberoninternal/travelbase-website/dist/components/Formed';
import { withDefaultBookingValues } from '@oberoninternal/travelbase-website/dist/utils/trip';
import { useTenantContext } from '@oberoninternal/travelbase-website/dist/context/TenantContext';
import SearchBar from '@oberoninternal/travelbase-website/dist/components/SearchBar';
import {
    setSearchBoxValuesToStorage,
    useSearchBoxValuesFromStorage,
} from '@oberoninternal/travelbase-website/dist/utils/searchBoxValuesFromStorage';
import { OptionType } from '@oberoninternal/travelbase-ds/components/form/SelectInput';
import { Booking } from '@oberoninternal/travelbase-website/dist/entities/Booking';
import { FormattedMessage } from 'react-intl';

interface Values {
    accommodationType: OptionType['value'];
    booking: Booking;
}

const SearchAndBook = () => {
    const { push } = useRouter();
    const validationSchema = getSearchValidationSchema();
    const { brandConfig } = useTenantContext();
    const storedSearch = useSearchBoxValuesFromStorage();

    return (
        <Wrapper>
            <Formed<Values>
                handleSubmit={async values => {
                    const { accommodationType, booking } = values;
                    setSearchBoxValuesToStorage(values);
                    await push({
                        pathname: `/search`,
                        query: {
                            ...withDefaultBookingValues(booking),
                            ...(accommodationType && { accommodationType }),
                            trip: booking.trip ? JSON.stringify(booking.trip) : undefined,
                        },
                    });
                }}
                initialValues={getInitialSearchBoxValues(brandConfig, storedSearch)}
                enableReinitialize
                validationSchema={validationSchema}
                skipPrompt
            >
                {() => (
                    <SearchBar
                        hideSearchIcon
                        variant="homeBar"
                        homeBarLabel={<FormattedMessage defaultMessage="Accommodaties" />}
                    />
                )}
            </Formed>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    width: 100%;
`;

export default SearchAndBook;
